import React, { useEffect } from 'react';
import { Edit } from '@mui/icons-material';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import MessageIcon from '@mui/icons-material/Message';
import HelpIcon from '@mui/icons-material/Help';

const ProfileDetails = ({ customer }) => {

  // let preference = <HelpIcon/>
  // if(customer["Customer Preferences"] === "email"){
  //   preference = <EmailIcon/> 
  // }else if(customer["Customer Preferences"] === "call"){
  //   preference = <CallIcon/>
  // }else if(customer["Customer Preferences"] === "In person"){
  //   preference = <PersonPinIcon/>
  // }else if(customer["Customer Preferences"] === "message"){
  //   preference = <MessageIcon/>
  // }else{
  //   preference = <HelpIcon/>
  // }

  const preferenceIcons = {
    email: <EmailIcon className='relative top-0'/>,
    call: <CallIcon className='relative top-0'/>,
    "In person": <PersonPinIcon className='relative top-0'/>,
    message: <MessageIcon className='relative top-0'/>
  }
  const preference = preferenceIcons[customer["Customer Preferences"]]

  if (!customer) return null;
 
  const details = [
    { label: 'Customer Name', value: customer['Customer Name'] },
    { label: 'Customer ID', value: customer['Customer ID'] },
    { label: 'Age', value: customer['Ageband'] },
    { label: 'Annual Income', value: `$${customer['Annual Income'].toLocaleString()}` },
    { label: 'Month On Book', value: customer['Months on Book'] },
    { label: 'Client Segment', value: customer['Client Segment'] },
    { label: 'Gender', value: customer['Gender'] },
    { label: 'Marital Status', value: customer['Marital Status'] },
    { label: 'Country', value: customer['Country Code'] },
    { label: 'RM Code', value: customer['RM Code'] },
    { label: 'Customer Status', value: customer['Customer Status'] },
    { label: 'Open Date', value: customer['Customer Open Date'] }
  ];
 
  return (
    <div className="bg-[#1A1A1A] p-6 rounded-xl border border-[#2A2A2A] shadow-xl">
      <div className="flex justify-between items-start mb-6">
        <h3 className="text-lg font-semibold text-[#FFFFFF]">Profile Details</h3>
        <h4 className="text-lg font-semibold text-[#B4E50D]">
          Customer Preference: {preference}
        </h4>
      </div>
      
      <div className="flex gap-6">
      
      <div className="flex-grow overflow-x-auto">
          <table className="min-w-full">
            <tbody>
            {details.map((detail, index) => (
              <tr key={index} className={index % 2 === 0 ? 'bg-[#2A2A2A]' : 'bg-[#1A1A1A]'}>
              <td className={`py-2 px-4 text-sm font-medium whitespace-nowrap ${detail.label === 'Client Segment' ? 'text-orange-500' : 'text-[#B0B0B0]'}`}>
                {detail.label}
              </td>
              <td className={`py-2 px-4 text-sm whitespace-nowrap ${detail.label === 'Client Segment' ? 'text-orange-500' : 'text-[#FFFFFF]'}`}>
                {detail.value}
              </td>
              </tr>
            ))}
            </tbody>
          </table>
      </div>
      </div>
    </div>
  );
};
 
export default ProfileDetails;